"use client";

import React, { useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { GrFormPrevious, GrFormNext } from "react-icons/gr";
import { testimonials } from "../../utils/constants";
import TooltipWithReadMore from "../common/TolltipWithReadMore";
import { Modal } from "../common/Modal";
import quotesIcon from "../../assets/icons-quotes.png";

const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left: "-36px",
        zIndex: 1,
        border: "1px solid #ff9900",
        borderRadius: "50%",
        padding: "0.5rem",
        width: "auto",
        height: "auto",
        background: "white",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
      onClick={onClick}
    >
      <GrFormPrevious size={20} color="#ff9900" />
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: "-35px",
        zIndex: 1,
        border: "1px solid #ff9900",
        borderRadius: "50%",
        padding: "0.5rem",
        width: "auto",
        height: "auto",
        background: "white",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
      onClick={onClick}
    >
      <GrFormNext size={20} color="#ff9900" />
    </div>
  );
};

const TestimonialCard = ({
  content,
  name,
  url,
  designation,
  rating,
  onReadMoreClick = () => {},
  showReadMore = true,
}) => {
  return (
    <div
      className={`bg-white p-4 sm:p-6 rounded-lg shadow-md relative flex flex-col items-start shadow-lg my-6 w-[95%] sm:w-full ${
        showReadMore ? "h-[300px]" : ""
      }`}
    >
      {/* Stars */}
      <div className="flex mb-3 sm:mb-4">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 sm:w-5 sm:h-5 ${
              i < rating ? "text-yellow-400" : "text-gray-300"
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>

      {/* Quote Icon */}
      <div className="absolute top-3 right-3 sm:top-4 sm:right-4">
        <img
          src={quotesIcon}
          alt="quotes"
          className="w-6 h-6 sm:w-8 sm:h-8 opacity-50"
        />
      </div>

      {/* Testimonial Text */}
      {showReadMore ? (
        <TooltipWithReadMore
          content={content}
          clampLines={4}
          onReadMoreClick={onReadMoreClick}
        />
      ) : (
        <div className="mb-3 sm:mb-4">
          <span className="text-[12px] sm:text-[13px] lg:text-md text-gray-700 text-left overflow-hidden text-ellipsis cursor-default">
            {content}
          </span>
        </div>
      )}

      {/* User Info */}
      <div className="flex items-center mt-auto">
        <img
          src={url}
          alt={name}
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full mr-3 sm:mr-4 object-cover"
        />
        <div className="flex flex-col items-start">
          <h4 className="text-[13px] sm:text-[14px] lg:text-lg font-semibold text-gray-800 text-left">
            {name}
          </h4>
          <p className="text-[11px] sm:text-[13px] lg:text-[14px] text-[#848383] text-left">
            {designation}
          </p>
        </div>
      </div>
    </div>
  );
};

export default function Testimonials() {
  const [modalDetails, setModalDetails] = useState({
    open: false,
    details: null,
  });

  const settings = {
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoPlay: true,
    speed: 500,
    infinite: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="my-7 flex flex-col space-y-5 max-w-[1380px] mx-auto">
      <div className="mx-[10px] sm:mx-[20px]">
        <div className="px-[0.5rem] sm:px-[1rem]">
          <div className="mx-auto my-[1.5rem] sm:my-[2rem] relative">
            <Slider {...settings}>
              {testimonials.map((i) => {
                return (
                  <div key={i.fields.name} className="px-1 sm:px-2">
                    <TestimonialCard
                      {...i.fields}
                      onReadMoreClick={() => {
                        setModalDetails({ open: true, details: i });
                      }}
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>

      {modalDetails.open && (
        <Modal
          isOpen={modalDetails.open}
          onClose={() => setModalDetails({ open: false, details: null })}
        >
          <div className="p-4 sm:p-6 relative">
            {/* Stars */}
            <div className="flex mb-3 sm:mb-4">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className={`w-3 h-3 sm:w-5 sm:h-5 ${
                    i < modalDetails.details.fields.rating
                      ? "text-yellow-400"
                      : "text-gray-300"
                  }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>

            {/* Quote Icon */}
            <div className="absolute top-3 right-3 sm:top-4 sm:right-4">
              <img
                src={quotesIcon}
                alt="quotes"
                className="w-5 h-5 sm:w-8 sm:h-8 opacity-50"
              />
            </div>

            {/* Testimonial Text */}
            <div className="mb-4 sm:mb-6">
              <span className="text-[11px] sm:text-[14px] lg:text-[15px] text-gray-700 text-left leading-relaxed">
                {modalDetails.details.fields.content}
              </span>
            </div>

            {/* User Info */}
            <div className="flex items-center">
              <img
                src={modalDetails.details.fields.url}
                alt={modalDetails.details.fields.name}
                className="w-8 h-8 sm:w-12 sm:h-12 rounded-full mr-3 sm:mr-4 object-cover"
              />
              <div className="flex flex-col items-start">
                <h4 className="text-[12px] sm:text-[15px] lg:text-[16px] font-semibold text-gray-800 text-left">
                  {modalDetails.details.fields.name}
                </h4>
                <p className="text-[11px] sm:text-[13px] lg:text-[14px] text-[#848383] text-left">
                  {modalDetails.details.fields.designation}
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
